import { styled } from '@mui/material';
import { TOGGLE } from '../toggleConstants.js';

const HORIZONTAL_OFFSET = TOGGLE.trackWidth / 2 - TOGGLE.thumbSize / 2 - TOGGLE.thumbOffset;
const ToggleThumb = styled("span")(({ theme, $checked }) => (Object.assign({ display: "inline-flex", justifyContent: "center", alignItems: "center", position: "absolute", top: "50%", transform: "translate(-50%, -50%)", width: TOGGLE.thumbSize, height: TOGGLE.thumbSize, borderRadius: TOGGLE.radius, transition: `left ${TOGGLE.animationDuration}`, backgroundColor: theme.palette.background.paper, left: `calc(50% - ${HORIZONTAL_OFFSET}px)` }, ($checked && {
    left: `calc(50% + ${HORIZONTAL_OFFSET}px)`,
}))));

export { ToggleThumb };
//# sourceMappingURL=ToggleThumb.js.map
